export interface IOrganisation {
  id: number;
  name: string;
  addressLines: string[];
  telephone: string;
  endComment: string;
  website: string;
  logo: string;
}

export const defaultOrganisation: IOrganisation = {
  id: 0,
  name: "",
  addressLines: ["support street"],
  telephone: "",
  endComment: "",
  website: "",
  logo: "",
};
